// @ts-nocheck
/* eslint-disable */
import Scene from "~/scene";

/**
 * projde vsechny pixelove souradnice trasy a najde nejblizsi bod nebo usek
 * @param {Array} pixels pole pixelových souřadnic (trasy)
 * @param {SceneCoords} pxCoord referenční souřadnice
 * @returns {object}
 */
Mapy.Util.getPointAndFraction = function(pixels, pxCoord) {
	/* projdeme vsechny pixelove souradnice trasy a najdeme:
	   1) nejblizsi bod, NEBO
	   2) nejblizsi usek
	*/

	var bestDistance = Infinity;
	var bestPoint = null; /* ScenePixel */
	var M = pxCoord;
	var index = 0;

	var total = 0;
	var part = 0;
	var prev = 0;

	for (var i=0;i<pixels.length;i++) {
		var A = pixels[i];
		var dist = A.distance(M);


		if(i > 0) { /* celkova vzdalenos v pixelech */
		var pxDist = pixels[prev].distance(A)
			total += pxDist
			prev = ++prev < pixels.length - 1 ? prev : pixels.length - 1;
		}

		if (dist < bestDistance) {
			bestDistance = dist;
			bestPoint = A;
			index = i;
		}

		if (i == pixels.length-1) { continue; } /* posledni bod uz nema usek */

		/* najit vzdalenost mysi od cary */
		var B = pixels[i+1];
		var V = B.clone().minus(A);
		var k = -(A.x*V.x - M.x*V.x + A.y*V.y - M.y*V.y) / (V.x*V.x + V.y*V.y);

		if (k >= 0 && k <= 1) { /* kolmy prumet mysi se nachazi na usecce AB */
			V.x *= k;
			V.y *= k;
			V.plus(A);
			var dist = V.distance(M);

			if (dist < bestDistance) {
				bestDistance = dist;
				bestPoint = V;
				index = i;
			}
		}


	} /* pro vsechny pixelove viditelne body trasy */

	/* pocitam vzdalenost k vypoctenemu bodu abzch ho mohl zvyraznit na vyskovem profilu*/
	let distance = 0;
	var arr =  [].concat(pixels)
	arr.splice(index+1,0,bestPoint)
	var D = 0;
	for(var i = 0; i < index+1; i++) {
		var d = arr[i].distance(arr[i+1]);
		distance += Scene.pixelToCoords(arr[i]).distance(Scene.pixelToCoords(arr[i+1]));
		D+=d;
	}
	/* procentualne udana vzdalenost k nelezenemu bodu na trase */
	var frac = D/total;

	return {
		fraction:frac,
		bestPoint:bestPoint, // kolmy prumet pxCoord na caru geometrie
		index: index, // index v ramci geometrie trasy
		bestDistance : bestDistance,
		distance,
	}
};

/**
 * Na jaký zoom se má zoomovat při zobrazení daného poie?
 * @param {object} poi data o POI, jak je vrací poiserver
 * @returns {int} zoom, na který se má detail zazoomovat
 */
Mapy.Util.computeZoom = function(poi) {
	let typeIdToZoom = typeId => {
		/**
		 * zoom 16 pro bodové arei v těchto areatype:
			9 Místní název
			120 - Využití území
			119 - Obydlená území
			15 - Sídliště, čtvrť
			127 - Mys
			12 - nevim co to je, ale bylo to predtim pro 16 zoom
		* zoom 12 pro bodové arei v těchto areatype:
			104 - Záliv
			105 - Ledovec
			109 - Průliv, úžina
			113 - Fjord
			121 - Pevninská šíje
			117 - Vojenská oblast
		*/
		if ([9, 12, 120, 119, 15, 127].indexOf(typeId) != -1) {
			return 16;
		}
		else if ([104, 105, 109, 113, 121, 117].indexOf(typeId) != -1) {
			return 12;
		}
		else {
			return 8;
		}
	};
	let typeIdZoom = typeIdToZoom(poi.typeId);
	// mapovani zoomu podle source
	let zoomData = {
		ward: 13,
		quar: 13,
		osmm: 12,
		muni: 12,
		dist: 9,
		osma: typeIdZoom,
		area: typeIdZoom,
		regi: 6,
		coun: 3,
		osms: 14
	};
	// zoom data podle source; def. zoom 17
	return zoomData[poi.source === "osm" && poi.origin ? poi.origin : poi.source] || 17;
};

/**
 * spočte obsah plochy
 * @param {Array} points pole polí [x, y]
 * @param {Bool} forMercator spočítat pro mercator?
 * @returns {float}
 */
Mapy.Util.polygonArea = function(points, forMercator) {
	var polygonArea = 0;
	var count = points.length;
	var last = points[count - 1];
	// secist vsechny Y, podelis poctem bodu - teziste
	var sumY = 0;
	var countY = 0;

	for (var i = 0; i < count; i++) {
		var c = points[i];
		polygonArea += last[0] * c[1] - c[0] * last[1];
		sumY += c[1];
		countY++;
		last = c;
	}

	var area = Math.abs(polygonArea * 0.5);

	if (forMercator) {
		var wgs = Scene.coordsFromMercator(0, sumY / countY).toWGS84();
		var cv = Math.cos(wgs[1] / 180 * Math.PI);
		area *= Math.pow(cv, 2);
	}

	return area;
};

/**
 * spočte obsah plochy
 * @param {object} startCoords x, y
 * @param {object} endCoords x, y
 * @param {int} steps počet kroků mezi začátkem a koncem
 * @returns {Array} pole souřadnic
 */
Mapy.Util.getMercatorPoints = (function() {
	/**
	 * Ziskani bodu mezi dvema vstupnimi body - bere v potaz zakriveni zeme.
	 *
	 * @param  {SceneCoords} start Pocatecni bod
	 * @param  {SceneCoords} end Konecny bod
	 * @param  {Float} factor <0;1> Vzdalenost mezi zacatkem a koncem
	 * @return {SceneCoords}
	 */
	function _getMiddlePoint(start, end, factor) {
		var lat1 = start.y / 180 * Math.PI;
		var lat2 = end.y / 180 * Math.PI;
		var lon1 = start.x / 180 * Math.PI;
		var lon2 = end.x / 180 * Math.PI;

		var d = Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon1 - lon2));
		var A = Math.sin((1 - factor) * d) / Math.sin(d);
		var B = Math.sin(factor * d) / Math.sin(d);
		var x = A * Math.cos(lat1) * Math.cos(lon1) + B * Math.cos(lat2) * Math.cos(lon2);
		var y = A * Math.cos(lat1) * Math.sin(lon1) + B * Math.cos(lat2) * Math.sin(lon2);
		var z = A * Math.sin(lat1) + B * Math.sin(lat2);

		var lat_f = Math.atan2(z, Math.sqrt(x * x + y * y)) / Math.PI * 180;
		var lon_f = Math.atan2(y, x) / Math.PI * 180;

		return Scene.coordsFromWGS84(lon_f, lat_f);
	};

	/**
	 * Test bodu - min, max X -> pokud je mensi jak 180 tak to vyhovuje, jinak se jde pres datovou hranici.
	 *
	 * @param  {Array} points Pole s body
	 * @return {Boolean}
	 */
	function _testPoints(points) {
		var minX = Infinity;
		var maxX = -Infinity;

		points.forEach(function(point) {
			if (point.x > maxX) {
				maxX = point.x;
			}

			if (point.x < minX) {
				minX = point.x;
			}
		});

		var distX = Math.abs(minX) + Math.abs(maxX);

		return (distX < 180);
	}

	return function(startCoords, endCoords, steps) {
		steps = typeof steps !== "number" ? 25 : steps;

		var outPoints = [];
		var factor = 0;
		var factorInc = 1 / steps;
		// pocatecni bod + (krivka) + koncovy bod
		var points = [startCoords];

		for (var i = 0; i < steps - 1; i++) {
			factor += factorInc;

			var cp = _getMiddlePoint(startCoords, endCoords, factor);
			points.push(cp);
		}

		points.push(endCoords);

		if (_testPoints(points)) {
			outPoints = points;
		}
		else {
			outPoints = [startCoords, endCoords];
		}

		return outPoints;
	};
})();

/**
 * Najde průsečík bodu a křivky
 * @param {object} point
 * @param {Array} lines
 * @param {int} maxDistance
 * @returns {Bool} prochází křivky bodem?
 */
Mapy.Util.linesPointIntersection = (function() {
	function dist2(v, w) { return (v.x - w.x) * (v.x - w.x) + (v.y - w.y) * (v.y - w.y) }

	function pointLineDistance(point, line) {
		var l2 = dist2(line.start, line.end);
		if (l2 == 0) return dist2(point, line.start);
		var t = ((point.x - line.start.x) * (line.end.x - line.start.x) + (point.y - line.start.y) * (line.end.y - line.start.y)) / l2;
		t = Math.max(0, Math.min(1, t));

		return dist2(point, {
			x: line.start.x + t * (line.end.x - line.start.x),
			y: line.start.y + t * (line.end.y - line.start.y)
		});
	}

	return function(point, lines, maxDistance) {
		var test = false;

		lines.every(function(line) {
			var distance = Math.sqrt(pointLineDistance(point, line));

			if (distance <= maxDistance) {
				test = true;
				return false;
			}
			else {
				return true;
			}
		});

		return test;
	};
})();

Mapy.Util.filterCoords = function(coordsArray, options) {
	if (coordsArray.length === 1) {
		return coordsArray;
	}

	var opts = Object.assign({
		diameter: 0
	}, options);

	for (var testedIndex = 0; testedIndex < coordsArray.length; testedIndex++) {
		var tested = Scene.coordsToPixel(coordsArray[testedIndex]);
		var index = [];

		for (var coordsIndex = testedIndex+1; coordsIndex < coordsArray.length; coordsIndex++) {
			var distance = tested.distance(Scene.coordsToPixel(coordsArray[coordsIndex]));

			if (distance < opts.diameter) {
				index.push(coordsIndex);
			}
		}

		while (index.length) {
			coordsArray.splice(index.pop(), 1);
		}
	}

	return coordsArray;
};
